/* eslint-disable no-use-before-define */

export function ContactPanel (options) {
    this.options = this.extend({
        wrapper: document,
        callButtonDataAttr: 'data-call',
        whatsAppButtonDataAttr: 'data-whatsapp',
        SMSButtonDataAttr: 'data-sms',
        contactInfoDataAttr: 'data-contact-info',
        actionButtonClasses: 'btn btn-lg action-button',
        cancelButtonClasses: 'btn btn-lg action-button cancel-button',
        panelWrapperClasses: 'contact-panel-wrapper',
        panelDrawerClasses: 'contact-panel-drawer',
        iconWrapperClasses: 'contact-icon',
        callIconClasses: 'fa fa-phone',
        whatsAppIconClasses: 'fa fa-whatsapp',
        SMSIconClasses: 'fa fa-mobile-phone',
        facebookUID: '',
        googlePhoneTrack: '',
        googleConversion: '',
        isOpened: true
    }, options);
    this.init(options);
};

ContactPanel.prototype.extend = function (a, b) {
    for (var key in b) {
        if (b.hasOwnProperty(key)) {
            a[key] = b[key];
        }
    }
    return a;
};

ContactPanel.prototype.init = function (options) {
    this.isIOS = /iPad|iPhone|iPod|Mac OS/.test(navigator.userAgent) && !window.MSStream;

    this.mergeOptions(options);
    this.createWrapper(); // common VUE PhoneButtons.vue
    this.createDrawer(); // common VUE PhoneButtons.vue

    // To get logic better:
    // https://git.oft-e.com/vehicle-project/mainsite-backend/-/blob/cb870aeaadaa774ee56d08113cdc6e298de3754c/public_html/default/responsive/js/ContactPanel.js
    // https://ucni-tracker.oft-e.com/issues/12552
    // https://ucni-tracker.oft-e.com/attachments/download/14195/Demo.zip

    this.activateCallButton(); // ./components/Call.vue
    this.activateSMSButton(); // ./components/Sms.vue
    this.activateWhatsAppButton(); // ./components/WhatsApp.vue
};

ContactPanel.prototype.mergeOptions = function (options) {
    this.options = Object.assign({}, this.options, options);
};

ContactPanel.prototype.createWrapper = function () {
    var that = this;

    this.wrapper = document.createElement('div');
    this.wrapper.className = this.options.panelWrapperClasses;
    this.wrapper.addEventListener('click', function () {
        that.hideContactPanel();
    });
};

ContactPanel.prototype.createDrawer = function () {
    this.drawer = document.createElement('div');
    this.drawer.className = this.options.panelDrawerClasses;
    this.wrapper.appendChild(this.drawer);
    document.querySelector('body').appendChild(this.wrapper);
};

ContactPanel.prototype.activateCallButton = function () {
    var that = this;

    this.callButton = this.options.wrapper.querySelector('[' + this.options.callButtonDataAttr + ']');

    if (this.callButton) {
        this.callButton.addEventListener('click', function () {
            that.updateData(that.callButton);
        });
    }
};

ContactPanel.prototype.activateSMSButton = function () {
    var that = this;

    this.smsButton = this.options.wrapper.querySelector('[' + this.options.SMSButtonDataAttr + ']');

    if (this.smsButton) {
        this.smsButton.addEventListener('click', function () {
            that.updateData(that.smsButton, false, true);
        });
    }
};

ContactPanel.prototype.activateWhatsAppButton = function () {
    var that = this;

    this.whatsAppButton = this.options.wrapper.querySelector('[' + this.options.whatsAppButtonDataAttr + ']');

    if (this.whatsAppButton) {
        if (!this.options.isOpened) {
            this.whatsAppButton.parentElement.parentNode.removeChild(this.whatsAppButton.parentElement);
        }
        this.whatsAppButton.addEventListener('click', function () {
            that.updateData(that.whatsAppButton, true);
        });
    }
};

ContactPanel.prototype.updateData = function (button, isWhatsApp, isSMS) {
    // todo: VUE: the app has to depend of data - not from HTML selements
    var jsonData = button.getAttribute('data-contacts');
    var obj = JSON.parse(jsonData);

    this.generateButtons(obj, isWhatsApp, isSMS);
    this.showContactPanel();
};

ContactPanel.prototype.generateButtons = function (dataObj, whatsApp, SMS) {
    this.emptyDrawer();

    for (var i = 0; i < dataObj.length; i++) {
        var obj = dataObj[i];

        var contactButton = document.createElement('a');
        contactButton.innerHTML = obj['Display'];
        contactButton.className = this.options.actionButtonClasses;

        var label = '';
        if (SMS === true) {
            label = 'textsms';
            contactButton = this.generateSMSButton(contactButton, obj);
            this.registerListener(contactButton, obj['Number'], SMS);
            this.clicksTracking(contactButton, this.options.smsStatId);
        } else if (whatsApp == true) {
            label = 'whatsapp';
            contactButton = this.generateWhatsAppButton(contactButton, obj);
            this.registerListener(contactButton, obj['Number'], SMS);
            this.clicksTracking(contactButton, this.options.whatsAppStatId);
        } else {
            label = 'mobileclick';
            contactButton = this.generateCallButton(contactButton, obj);
            this.clicksTracking(contactButton, this.options.callStatId);
        }
        this.googleConversionTracking(contactButton, obj['Number']);
        this.facebookTracking(contactButton, this.options.facebookUID);
        this.googlePhoneTrack(contactButton, label);

        this.drawer.appendChild(contactButton);
    }

    this.generateCancelButton();
};

ContactPanel.prototype.clicksTracking = function (contactButton, statId) {
    var that = this;
    if (statId) {
        contactButton.addEventListener('click', function () {
            stat_counter(statId, that.getStatKeyName(), that.options.domainName);
        });
    }
};

ContactPanel.prototype.googleConversionTracking = function (contactButton, number) {
    if (this.options.googleConversion) {
        contactButton.addEventListener('click', function () {
            gtag_report_conversion('tel:' + number);
        });
    }
};

ContactPanel.prototype.facebookTracking = function (contactButton, facebookUID) {
    if (facebookUID) {
        contactButton.addEventListener('click', function () {
            fbq('track', 'Purchase', {
                content_type: 'product',
                content_ids: [facebookUID],
                value: 0,
                currency: 'GBP'
            });
        });
    }
};

ContactPanel.prototype.googlePhoneTrack = function (contactButton, label) {
    if (this.options.googlePhoneTrack) {
        contactButton.addEventListener('click', function () {
            gtag_phone_buttons_track(label);
        });
    }
};

ContactPanel.prototype.registerListener = function (button, number, SMS) {
    var that = this;
    button.addEventListener('click', function () {
        var message = that.options.messageText
            ? that.getPreparedMessage()
            : '';
        var link = (SMS == true)
            ? 'sms:' + number + (message ? (that.isIOS ? '/&' : '?') + 'body=' + message : '')
            : 'https://api.whatsapp.com/send?phone=' + number +
            '&text=' + message + that.options.whatsappHint + '&source=&data=';
        window.open(encodeURI(link), '_blank');
    });
};

ContactPanel.prototype.getPreparedMessage = function () {
    const link = this.loadAJAX(
        '/ajax_request.php?request=get_advert_link&link=' + this.options.advertLink + '&id=' + this.options.vehicleId
    );
    return this.options.messageText.replace('{AdvertLink}', link ? link : this.options.advertLink) + ' ';
};

ContactPanel.prototype.loadAJAX = function (url) {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', url, false);
    xmlhttp.send();
    return xmlhttp.responseText;
};

ContactPanel.prototype.generateCancelButton = function () {
    var that = this;

    var cancelButton = document.createElement('button');
    cancelButton.innerHTML = 'Cancel';
    cancelButton.className = this.options.cancelButtonClasses;
    cancelButton.addEventListener('click', function () {
        that.hideContactPanel();
    });

    this.drawer.appendChild(cancelButton);
};

ContactPanel.prototype.generateCallButton = function (button, obj) {
    var icon = this.generateButtonIcon(this.options.callIconClasses);

    button.href = 'tel:' + obj['Number'];
    button.insertBefore(icon, button.firstChild);
    return button;
};

ContactPanel.prototype.generateSMSButton = function (button, obj) {
    var icon = this.generateButtonIcon(this.options.SMSIconClasses);

    button.insertBefore(icon, button.firstChild);
    return button;
};

ContactPanel.prototype.generateWhatsAppButton = function (button, obj) {
    var icon = this.generateButtonIcon(this.options.whatsAppIconClasses);

    button.insertBefore(icon, button.firstChild);
    return button;
};

ContactPanel.prototype.getStatKeyName = function () {
    return this.options.vehicleId
        ? this.options.vehicleId + '_' + this.options.statUserId
        : this.options.statUserId
};

ContactPanel.prototype.generateButtonIcon = function (classes) {
    var iconWrapper = document.createElement('div');
    iconWrapper.className = this.options.iconWrapperClasses;

    var icon = document.createElement('span');
    icon.className = classes;

    iconWrapper.appendChild(icon);
    return iconWrapper;
};

ContactPanel.prototype.showContactPanel = function () {
    this.wrapper.classList.add('active');
};

ContactPanel.prototype.hideContactPanel = function () {
    this.wrapper.classList.remove('active');
    this.emptyDrawer();
};

ContactPanel.prototype.emptyDrawer = function () {
    this.drawer.innerHTML = '';
};

ContactPanel.prototype.clean = function () {
    this.wrapper.parentNode.removeChild(this.wrapper);
}
